import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useNavigate } from "react-router-dom";
import {
  resetUserPassword,
  validateUserExists,
} from "@services/API/Requests/UserRequests";
import { USER } from "@types/user";
import { TranslateErrorMessage } from "@services/ErrorHandling";
import { GetPasswordPolicy } from "@services/Utilities";
import { error_message } from "@constants/Errors";
import messages from "@constants/Messages";
import { GENERIC_PATHS } from "@constants/NavigationPaths";

export const UseUserPasswordResetForm = () => {
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  const [userData, setUserData] = useState<USER | undefined>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  const myUserPage: boolean = true;
  const id: string = "none";

  const passwordPolicy: string = GetPasswordPolicy();

  const noMatchToast = () => toast.error(error_message.password.no_match);
  const blankFieldToast = () => toast.error(error_message.password.blank_field);
  const errorToast = (error) => toast.error(error);
  const passwordChangedToast = () => toast.success(messages.password.success);

  const [errors, setErrors] = useState({
    password: false,
    verifyPassword: false,
    noMatch: false,
  });

  const verifyFields = () => {
    return !Object.values(errors).some((error) => error === true);
  };

  const updateError = (field, value) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: value,
    }));
  };

  useEffect(() => {
    const fetchUserData = async () => {
      await validateUserExists(
        setUserData,
        setLoading,
        setError,
        id, // no id as we use the token
        myUserPage, // myUserPage = true
      );
    };

    fetchUserData();
  }, []);

  const verifyBlankFields = () => {
    return newPassword !== "" && confirmPassword !== "";
  };

  const verifyNewPassword = () => {
    return newPassword === confirmPassword;
  };

  const verifyPasswords = (): boolean => {
    if (!verifyBlankFields()) {
      blankFieldToast();
      return false;
    }
    if (!verifyNewPassword()) {
      noMatchToast();
      return false;
    }

    if (!verifyFields()) {
      errorToast(error_message.generic.bad_field);
      return false;
    }

    return true;
  };

  const onCancel = () => {
    navigate(GENERIC_PATHS.home);
  };

  useEffect(() => {
    if (newPassword !== confirmPassword) {
      updateError("noMatch", true);
    } else {
      updateError("noMatch", false);
    }
  }, [newPassword, confirmPassword]);

  const onConfirm = async () => {
    let response;

    if (verifyPasswords()) {
      await resetUserPassword(confirmPassword, setLoading, setError)
        .then((response) => {
          if (response.status == 200) {
            passwordChangedToast();
          } else {
            const errorMessage = TranslateErrorMessage(response.message);
            console.error(errorMessage);
            setError(errorMessage);
            errorToast(errorMessage);
          }
        })
        .catch((error) => {
          const errorMessage = TranslateErrorMessage(response.message);
          console.error(errorMessage);
          setError(errorMessage);
          errorToast(errorMessage);
        });
      setLoading(false);
    }
  };

  return {
    loading,
    userData,
    newPassword,
    confirmPassword,
    errors,
    passwordPolicy,
    updateError,
    setNewPassword,
    setConfirmPassword,
    onConfirm,
    onCancel,
  };
};
